import { Instagram, Facebook } from "lucide-react";

// Threads and TikTok don't exist in lucide-react at this version — inline SVGs.
function ThreadsIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.019c.03-3.576.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.014-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.78 3.63 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.045.216.092.32.141 1.49.7 2.58 1.761 3.154 3.07.797 1.82.87 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.652zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z"/>
    </svg>
  );
}

function TikTokIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.75a8.16 8.16 0 0 0 4.77 1.52V6.81a4.85 4.85 0 0 1-1.84-.12z"/>
    </svg>
  );
}

const buildHref = (platform, value) => {
  if (!value) return null;
  const v = String(value).trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  const handle = v.replace(/^@+/, "");
  switch (platform) {
    case "threads": return `https://www.threads.net/@${handle}`;
    case "instagram": return `https://www.instagram.com/${handle}`;
    case "facebook": return `https://www.facebook.com/${handle}`;
    case "tiktok": return `https://www.tiktok.com/@${handle}`;
    default: return null;
  }
};

const PLATFORMS = [
  { key: "threads", label: "Threads", Icon: ThreadsIcon, color: "bg-[#000000] hover:bg-black text-white" },
  { key: "instagram", label: "Instagram", Icon: Instagram, color: "bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white" },
  { key: "facebook", label: "Facebook", Icon: Facebook, color: "bg-[#1877F2] hover:bg-[#0E5FCC] text-white" },
  { key: "tiktok", label: "TikTok", Icon: TikTokIcon, color: "bg-black hover:bg-neutral-800 text-white" },
];

export default function SocialIcons({ socials, size = 16, className = "" }) {
  if (!socials) return null;
  const active = PLATFORMS.map((p) => ({ ...p, href: buildHref(p.key, socials[p.key]) })).filter((p) => p.href);
  if (active.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-icons">
      {active.map(({ key, label, Icon, color, href }) => (
        <a key={key} href={href} target="_blank" rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className={`w-8 h-8 rounded-full ${color} grid place-items-center transition-transform hover:-translate-y-0.5`}
          title={label} aria-label={label} data-testid={`social-${key}`}>
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}

export { PLATFORMS };
